import React, { useEffect, useState } from 'react';
const slideshowImages = ['https://cdn.magicpatterns.com/uploads/bnDEJSDXPucCibzk4Uanrv/01-Eva-Schifferer-Rohrbachstraße_35-Frankfurt.jpg', 'https://cdn.magicpatterns.com/uploads/4ELKjXwbwY917i2nf8ur6k/02-Eva-Schifferer-Rohrbachstraße_35-Frankfurt.jpg', 'https://cdn.magicpatterns.com/uploads/7Tz57ovyUE22PzfeSMrFyb/03-Eva-Schifferer-Rohrbachstraße_35-Frankfurt.jpg'];
export const KontaktPage: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slideshowImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <div className="w-full bg-white" data-id="element-423">
      <section className="w-full py-16 px-6 md:px-12 lg:px-20" data-id="element-424">
        <div className="max-w-6xl mx-auto" data-id="element-425">
          <h1 className="text-4xl text-orange-500 font-light mb-8" data-id="element-426">
            Bereit für den Wandel?
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-427">
            <div data-id="element-428">
              <p className="mb-6 text-base text-gray-700 leading-relaxed" data-id="element-429">
                Lassen Sie uns sprechen und holen Sie sich Impulse für Ihre
                Veränderung!
              </p>
              <p className="mb-8 text-base text-gray-700 leading-relaxed" data-id="element-430">
                Rufen Sie mich an oder schreiben Sie mir – gerne klären wir in
                einem ersten unverbindlichen Informationsgespräch was ich für
                Sie tun kann.
              </p>

              <div data-id="element-431">
                <img src="https://cdn.magicpatterns.com/uploads/tBmhGqjQJWJcp38P9jQZv6/Eva-Schifferer-Kontakt.jpg" alt="Eva Schifferer" className="w-full h-auto object-cover rounded" data-id="element-432" />
              </div>
            </div>

            <div data-id="element-433">
              <form className="space-y-4" data-id="element-434">
                <div className="relative" data-id="element-435">
                  <input type="text" placeholder="Name *" className="w-full px-4 py-3 bg-gray-100 border-none rounded text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500" data-id="element-436" />
                </div>

                <div className="relative" data-id="element-437">
                  <input type="email" placeholder="E-Mail *" className="w-full px-4 py-3 bg-gray-100 border-none rounded text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500" data-id="element-438" />
                </div>

                <div className="relative" data-id="element-439">
                  <input type="tel" placeholder="Telefonnummer *" className="w-full px-4 py-3 bg-gray-100 border-none rounded text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500" data-id="element-440" />
                </div>

                <div className="relative" data-id="element-441">
                  <textarea placeholder="Nachricht *" rows={6} className="w-full px-4 py-3 bg-gray-100 border-none rounded text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none" data-id="element-442"></textarea>
                </div>

                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-443">
                  Für die Bearbeitung Ihrer Anfrage erheben, speichern und
                  verarbeiten wir Ihre Daten. Weitere Informationen finden Sie
                  in unserer Datenschutzerklärung unter{' '}
                  <a href="#" className="text-orange-500 hover:underline" data-id="element-444">
                    Datenschutz
                  </a>
                  .
                </p>

                <div className="flex items-center justify-between pt-4" data-id="element-445">
                  <button type="submit" className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded font-normal transition-colors" data-id="element-446">
                    Nachricht senden
                  </button>
                  <span className="text-sm text-gray-600" data-id="element-447">*erforderlich</span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full border-t border-gray-300 py-16 px-6 md:px-12 lg:px-20" data-id="element-448">
        <div className="max-w-6xl mx-auto" data-id="element-449">
          <h2 className="text-3xl text-orange-500 font-light mb-8" data-id="element-450">
            Anfahrtsskizze
          </h2>

          <p className="mb-8 text-base text-gray-700 leading-relaxed" data-id="element-451">
            Zentral gelegen im Frankfurter Nordend:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start" data-id="element-452">
            <div className="relative h-96 overflow-hidden rounded" data-id="element-453">
              {slideshowImages.map((image, index) => <img key={index} src={image} alt={`Rohrbachstraße 35 ${index + 1}`} className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000" style={{
              opacity: currentSlide === index ? 1 : 0
            }} data-id="element-454" />)}
            </div>

            <div className="space-y-4 text-sm text-gray-700" data-id="element-455">
              <div data-id="element-456">
                <p className="font-semibold mb-2" data-id="element-457">
                  Vom Frankfurter Hauptbahnhof
                </p>
                <ul className="space-y-1.5 ml-4" data-id="element-458">
                  <li className="flex items-start" data-id="element-459">
                    <span className="mr-2 mt-1.5 w-1 h-1 bg-gray-700 rounded-full flex-shrink-0" data-id="element-460"></span>
                    <span data-id="element-461">
                      Straßenbahnlinie 18 Richtung Preungesheim: Ausstieg an
                      Haltestelle Friedberger Landstraße (ca. 5–7 Minuten Fußweg
                      zur Rohrbachstraße 35)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-462">
                    <span className="mr-2 mt-1.5 w-1 h-1 bg-gray-700 rounded-full flex-shrink-0" data-id="element-463"></span>
                    <span data-id="element-464">
                      U-Bahn U4 oder U5 bis Bornheim Mitte (ca. 8–10 Minuten
                      Fußweg zur Rohrbachstraße 35)
                    </span>
                  </li>
                </ul>
              </div>

              <div data-id="element-465">
                <p className="font-semibold mb-2" data-id="element-466">Anfahrt mit dem Auto</p>
                <p className="mb-2" data-id="element-467">
                  Über die Friedberger Landstraße und Nibelungen- oder
                  Rothschildallee in die Rohrbachstraße abbiegen.
                </p>
                <p className="font-semibold mb-1.5" data-id="element-468">Parkmöglichkeiten:</p>
                <ul className="space-y-1.5 ml-4" data-id="element-469">
                  <li className="flex items-start" data-id="element-470">
                    <span className="mr-2 mt-1.5 w-1 h-1 bg-gray-700 rounded-full flex-shrink-0" data-id="element-471"></span>
                    <span data-id="element-472">
                      Parkmöglichkeiten befinden sich tagsüber entlang der
                      Rohrbachstraße und den umliegenden Straßen
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-473">
                    <span className="mr-2 mt-1.5 w-1 h-1 bg-gray-700 rounded-full flex-shrink-0" data-id="element-474"></span>
                    <span data-id="element-475">
                      Parkhaus Bürgerhaus Bornheim (Arnsburger Str. 24) ca. 1,0
                      km, etwa 12 Minuten zu Fuß
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-476">
                    <span className="mr-2 mt-1.5 w-1 h-1 bg-gray-700 rounded-full flex-shrink-0" data-id="element-477"></span>
                    <span data-id="element-478">
                      Parkhaus Mousonturm (Waldschmidtstraße 4) ca. 1,2 km, etwa
                      15 Minuten zu Fuß
                    </span>
                  </li>
                </ul>
              </div>

              <p className="font-semibold pt-2" data-id="element-479">
                Bitte klingeln Sie bei Studio Connect.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};